<template>
    <div style="border-bottom: 1px solid #e1e0e0; padding: 10px 0">
        <div class="pull-left">
            <log-line-headline :logLine="logLine"></log-line-headline>
        </div>

        <div class="pull-right">
            <log-line-actions :logLine="logLine" @edit="$emit('edit')" @resolve="$emit('resolve')" @postpone="$emit('postpone')"></log-line-actions>
        </div>

        <div class="clearfix"></div>
    </div>
</template>

<script>
    import LogLineActions from '@/components/LogLine/LogLineActions'
    import LogLineHeadline from '@/components/LogLine/LogLineHeadline'

    export default {
        components: {LogLineActions, LogLineHeadline},
        
        props: ['logLine']
    }
</script>
